/**
 * Demo-scene payload rendered by DemoSceneRenderer. Twin of the validated
 * shape in convex/demoScenes.ts (executeSetDemoScenes) — keep in sync.
 * Coordinates are CSS px in the captured page's space (1920-wide viewport;
 * y is document offset).
 */
export type DemoCameraKey = { at: number; x: number; y: number; zoom: number; ease?: string }
export type DemoCursorStep = { at: number; x: number; y: number; click?: boolean }
export type DemoRect = { x: number; y: number; w: number; h: number }

export type DemoScenePayload = {
  kind: 'title' | 'tilt' | 'browse' | 'outro'
  headline?: string
  sub?: string
  label?: string
  badge?: string
  cta?: string
  site?: string
  narration?: string
  // browse
  shot?: string
  shotSize?: { w: number; h: number }
  url?: string
  camera?: DemoCameraKey[]
  cursor?: DemoCursorStep[]
  calloutRect?: DemoRect
  // tilt
  shots?: string[]
  direction?: 'left' | 'right'
}

export type DemoStyle = {
  product?: string
  site?: string
  accent: string
  accentSecondary?: string
  theme?: 'dark' | 'light'
}

/** Fixed design space — scenes are authored at 1920x1080 and scaled to fit. */
export const DEMO_STAGE_W = 1920
export const DEMO_STAGE_H = 1080
